import { Stack, useTheme } from "@mui/material";
import { Camera, Image as ImageIcon, Paperclip } from "lucide-react";
import type { FC } from "react";
import { ChatComposerIconButton } from "web_myplann/Chat/Components/ChatComposerIconButton";
import { ChatComposerInput } from "web_myplann/Chat/Components/ChatComposerInput";
import { ChatComposerSendButton } from "web_myplann/Chat/Components/ChatComposerSendButton";

type Props = {
	value: string;
	onChange: (value: string) => void;
	onSend: () => void;
	onPickPhoto: () => void;
	onPickGallery: () => void;
	onPickFile: () => void;
	disabled: boolean;
};

export const ChatComposer: FC<Props> = ({
	value,
	onChange,
	onSend,
	onPickPhoto,
	onPickGallery,
	onPickFile,
	disabled,
}) => {
	const theme = useTheme();
	const canSend = value.trim().length > 0 && !disabled;

	return (
		<Stack
			direction="row"
			alignItems="flex-end"
			gap={0.6}
			flexShrink={0}
			px={0.8}
			pt={0.8}
			bgcolor={theme.palette.background.paper}
			pb="max(8px, env(safe-area-inset-bottom, 8px))"
		>
			<ChatComposerIconButton onClick={onPickPhoto} disabled={disabled}>
				<Camera size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</ChatComposerIconButton>
			<ChatComposerIconButton onClick={onPickGallery} disabled={disabled}>
				<ImageIcon size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</ChatComposerIconButton>
			<ChatComposerIconButton onClick={onPickFile} disabled={disabled}>
				<Paperclip size={theme.iconSize.md} color={theme.palette.blue[500]} />
			</ChatComposerIconButton>

			<ChatComposerInput value={value} onChange={onChange} onSubmit={onSend} />

			<ChatComposerSendButton onClick={onSend} active={canSend} />
		</Stack>
	);
};
